import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IListProjectItemRequest extends IBaseRequest {
    limit:              number;
    offset:             number;
    orderBy?:            string;
    countOnly?:          boolean;
    onlyMaster?:         boolean;
    onlySlave?:          boolean;
    addInvoice?:         string;
    folder?:             string;
    project?:            string;
    customer?:           string;
    provider?:           string;
    id?:                 string;
    activity?:           string;
    item?:               string;
    billingStatus?:      string;
    projectState?:       string;
    projectCustomState?: string;
    invoiceId?:          string;
    orderId?:            string;
    budgetId?:           string;
    groupBy?:            string;
    billingDate?:        string;
    billingDateFrom?:    string;
    billingDateTo?:      string;
    activityType?:       string;
    projectType?:        string;
    itemFilter?:         string;
    supplier?:           string;
    type?:               string;
    IDFILTER?:           Idfilter[];
    MASSCHANGE?:         Masschange;
    FILTER?:             Filter;
}
export interface Filter {
  COL?: Col[];
}
export interface Idfilter {
  id: string;
}
export interface Masschange {
  projectChange?:           string;
  project?:                 string;
  itemChange?:              string;
  item?:                    string;
  amountChange?:            string;
  amount?:                  string;
  currencyChange?:          string;
  currency?:                string;
  quantityChange?:          string;
  quantity?:                number;
  freeQuantityChange?:      string;
  freeQuantity?:            string;
  freeQuantityChangeType?:  string;
  totalQuantityChange?:     string;
  totalQuantity?:           string;
  totalQuantityChangeType?: string;
  totalAmountChange?:       string;
  totalAmount?:             string;
  fixAmountChange?:         string;
  fixAmount?:               string;
  vatChange?:               string;
  vat?:                     string;
  vatValue?:                string;
  billingStatusChange?:     string;
  billingStatus?:           string;
  billingDateChange?:       string;
  billingDate?:             string;
  taxationDateChange?:      string;
  taxationDate?:            string;
  noteChange?:              string;
  note?:                    string;
  fixTextChange?:           string;
  fixText?:                 string;
  splitInInvoiceChange?:    string;
  splitInInvoice?:          string;
}

export interface Col {
  name:        string;
  type:        string;
  value?:       string;
  negation?:    string;
  includeNull?: string;
}

export class ListProjectItemRequest extends BaseRequest implements IListProjectItemRequest {
  public limit:              number;
  public offset:             number;
  public orderBy?:            string;
  public countOnly?:          boolean;
  public onlyMaster?:         boolean;
  public onlySlave?:          boolean;
  public addInvoice?:         string;
  public folder?:             string;
  public project?:            string;
  public customer?:           string;
  public provider?:           string;
  public id?:                 string;
  public activity?:           string;
  public item?:               string;
  public billingStatus?:      string;
  public projectState?:       string;
  public projectCustomState?: string;
  public invoiceId?:          string;
  public orderId?:            string;
  public budgetId?:           string;
  public groupBy?:            string;
  public billingDate?:        string;
  public billingDateFrom?:    string;
  public billingDateTo?:      string;
  public activityType?:       string;
  public projectType?:        string;
  public itemFilter?:         string;
  public supplier?:           string;
  public type?:               string;
  public IDFILTER?:           Idfilter[];
  public MASSCHANGE?:         Masschange;
  public FILTER?:             Filter;

  constructor(server: string, session: string, limit: number, offset: number, otherOptions?: any) {
    super(server, session);
    this.limit = limit;
    this.offset = offset;
    this.orderBy = otherOptions.orderBy;
    this.countOnly = otherOptions.countOnly;
    this.onlyMaster = otherOptions.onlyMaster;
    this.onlySlave = otherOptions.onlySlave;
    this.addInvoice = otherOptions.addInvoice;
    this.folder = otherOptions.folder;
    this.project = otherOptions.project;
    this.customer = otherOptions.customer;
    this.provider = otherOptions.provider;
    this.id = otherOptions.id;
    this.activity = otherOptions.activity;
    this.item = otherOptions.item;
    this.billingStatus = otherOptions.billingStatus;
    this.projectState = otherOptions.projectState;
    this.projectCustomState = otherOptions.projectCustomState;
    this.invoiceId = otherOptions.invoiceId;
    this.orderId = otherOptions.orderId;
    this.budgetId = otherOptions.budgetId;
    this.groupBy = otherOptions.groupBy;
    this.billingDate = otherOptions.billingDate;
    this.billingDateFrom = otherOptions.billingDateFrom;
    this.billingDateTo = otherOptions.billingDateTo;
    this.activityType = otherOptions.activityType;
    this.projectType = otherOptions.projectType;
    this.itemFilter = otherOptions.itemFilter;
    this.supplier = otherOptions.supplier;
    this.type = otherOptions.type;
    this.IDFILTER = otherOptions.IDFILTER;
    this.MASSCHANGE = otherOptions.MASSCHANGE;
    this.FILTER = otherOptions.FILTER;
  }

  public toXml(): string {
    var parameters: string = super.toXml();

    parameters += this.makeNode(this.limit, 'limit');
    parameters += this.makeNode(this.offset, 'offset');
    parameters += this.makeNode(this.orderBy, 'orderBy');
    parameters += this.makeNode(this.countOnly, 'countOnly');
    parameters += this.makeNode(this.onlyMaster, 'onlyMaster');
    parameters += this.makeNode(this.onlySlave, 'onlySlave');
    parameters += this.makeNode(this.addInvoice, 'addInvoice');
    parameters += this.makeNode(this.folder, 'folder');
    parameters += this.makeNode(this.project, 'project');
    parameters += this.makeNode(this.customer, 'customer');
    parameters += this.makeNode(this.provider, 'provider');
    parameters += this.makeNode(this.id, 'id');
    parameters += this.makeNode(this.activity, 'activity');
    parameters += this.makeNode(this.item, 'item');
    parameters += this.makeNode(this.billingStatus, 'billingStatus');
    parameters += this.makeNode(this.projectState, 'projectState');
    parameters += this.makeNode(this.projectCustomState, 'projectCustomState');
    parameters += this.makeNode(this.invoiceId, 'invoiceId');
    parameters += this.makeNode(this.orderId, 'orderId');
    parameters += this.makeNode(this.budgetId, 'budgetId');
    parameters += this.makeNode(this.groupBy, 'groupBy');
    parameters += this.makeNode(this.billingDate, 'billingDate');
    parameters += this.makeNode(this.billingDateFrom, 'billingDateFrom');
    parameters += this.makeNode(this.billingDateTo, 'billingDateTo');
    parameters += this.makeNode(this.activityType, 'activityType');
    parameters += this.makeNode(this.projectType, 'projectType');
    parameters += this.makeNode(this.itemFilter, 'itemFilter');
    parameters += this.makeNode(this.supplier, 'supplier');
    parameters += this.makeNode(this.type, 'type');
    
    if(this.IDFILTER) {
      parameters += '<IDFILTER>';
      this.IDFILTER.forEach((idFilter) => {
        parameters += this.makeNode(idFilter.id, 'id');
      });
      parameters += '</IDFILTER>';
    }

    if(this.MASSCHANGE) {
      parameters += '<MASSCHANGE>';
      parameters += this.makeNode(this.MASSCHANGE.projectChange, 'projectChange');
      parameters += this.makeNode(this.MASSCHANGE.project, 'project');
      parameters += this.makeNode(this.MASSCHANGE.itemChange, 'itemChange');
      parameters += this.makeNode(this.MASSCHANGE.item, 'item');
      parameters += this.makeNode(this.MASSCHANGE.amountChange, 'amountChange');
      parameters += this.makeNode(this.MASSCHANGE.amount, 'amount');
      parameters += this.makeNode(this.MASSCHANGE.currencyChange, 'currencyChange');
      parameters += this.makeNode(this.MASSCHANGE.currency, 'currency');
      parameters += this.makeNode(this.MASSCHANGE.quantityChange, 'quantityChange');
      parameters += this.makeNode(this.MASSCHANGE.quantity, 'quantity');
      parameters += this.makeNode(this.MASSCHANGE.freeQuantityChange, 'freeQuantityChange');
      parameters += this.makeNode(this.MASSCHANGE.freeQuantity, 'freeQuantity');
      parameters += this.makeNode(this.MASSCHANGE.freeQuantityChangeType, 'freeQuantityChangeType');
      parameters += this.makeNode(this.MASSCHANGE.totalQuantityChange, 'totalQuantityChange');
      parameters += this.makeNode(this.MASSCHANGE.totalQuantity, 'totalQuantity');
      parameters += this.makeNode(this.MASSCHANGE.totalQuantityChangeType, 'totalQuantityChangeType');
      parameters += this.makeNode(this.MASSCHANGE.totalAmountChange, 'totalAmountChange');
      parameters += this.makeNode(this.MASSCHANGE.totalAmount, 'totalAmount');
      parameters += this.makeNode(this.MASSCHANGE.fixAmountChange, 'fixAmountChange');
      parameters += this.makeNode(this.MASSCHANGE.fixAmount, 'fixAmount');
      parameters += this.makeNode(this.MASSCHANGE.vatChange, 'vatChange');
      parameters += this.makeNode(this.MASSCHANGE.vat, 'vat');
      parameters += this.makeNode(this.MASSCHANGE.vatValue, 'vatValue');
      parameters += this.makeNode(this.MASSCHANGE.billingStatusChange, 'billingStatusChange');
      parameters += this.makeNode(this.MASSCHANGE.billingStatus, 'billingStatus');
      parameters += this.makeNode(this.MASSCHANGE.billingDateChange, 'billingDateChange');
      parameters += this.makeNode(this.MASSCHANGE.billingDate, 'billingDate');
      parameters += this.makeNode(this.MASSCHANGE.taxationDateChange, 'taxationDateChange');
      parameters += this.makeNode(this.MASSCHANGE.taxationDate, 'taxationDate');
      parameters += this.makeNode(this.MASSCHANGE.noteChange, 'noteChange');
      parameters += this.makeNode(this.MASSCHANGE.note, 'note');
      parameters += this.makeNode(this.MASSCHANGE.fixTextChange, 'fixTextChange');
      parameters += this.makeNode(this.MASSCHANGE.fixText, 'fixText');
      parameters += this.makeNode(this.MASSCHANGE.splitInInvoiceChange, 'splitInInvoiceChange');
      parameters += this.makeNode(this.MASSCHANGE.splitInInvoice, 'splitInInvoice');
      parameters += '</MASSCHANGE>';
    }

    if(this.FILTER) {
      parameters += '<FILTER>';
      if(this.FILTER.COL) {
        this.FILTER.COL.forEach((col) => {
          parameters += '<COL>';
          parameters += this.makeNode(col.name, 'name');
          parameters += this.makeNode(col.type, 'type');
          parameters += this.makeNode(col.value, 'value');
          parameters += this.makeNode(col.negation, 'negation');
          parameters += this.makeNode(col.includeNull, 'includeNull');
          parameters += '</COL>';
        });
      }
      parameters += '</FILTER>';
    }

    return super.wrapperXml('ListProjectItem', parameters);
  }
}
